import auth from '../auth';

export const getMenuItems = () => {
  const isEntidad = auth.isEntidadUser() || auth.isGestor();

  if (isEntidad) {
    return [{
      name: 'General',
      icon: 'fa fa-home',
      items: [
        {
          name: 'Expedientes',
          icon: 'fa fa-file-text-o',
          items: [
            {
              name: 'Encomienda',
              url: '/encomiendaprofesional/',
              permission: ''
            },
            {
              name: 'Visaciones',
              url: '/visaciones/',
              permission: ''
            },
          ]
        },
      ]
    }];
  }

  return [{
    name: 'General',
    icon: 'fa fa-home',
    items: [
      {
        name: 'Encomienda Profesional',
        url: '/formencomienda/',
        icon: 'fa fa-file-text',
        permission: ''
      },
      {
        name: 'Visaciones',
        url: '/visaciones/',
        icon: 'fa fa-check-square-o',
        permission: ''
      },
      {
        name: 'Historial Encomienda',
        url: '/historialencomienda/',
        icon: 'fa fa-history',
        permission: ''
      },
      {
        name: 'Estado de Deuda',
        url: '/ctacte/estadodeuda',
        icon: 'fa fa-dollar',
        permission: ''
      },
      {
        name: 'Cobros Deudas',
        url: '/ctacte/cobrosdeudas',
        icon: 'fa fa-money',
        permission: ''
      },
      {
        name: 'Eventos Calendar',
        url: '/eventoscalendar/',
        icon: 'fa fa-calendar',
        permission: ''
      },
    ]
  }];
};

export default {
  root: getMenuItems()
};



// WEBPACK FOOTER //
// ./src/components/Menues.js